import React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { DateFormatters } from 'app/infrastructure/data/types';
import { Tag } from 'app/components/tag';

import { DeleteMessageMenu } from '../../common/delete-message-menu';
import { AdministrationMessagesTranslation } from '../../constants';
import { UpdateHandler, DeleteHandler } from '../types';
import { AdministrationListMessage } from '../types-store';
import { MessagesListItemPublish } from './messages-list-item-publish';
import { ExpandableMessage } from './expandable-message';

import styles from './messages-list-item.scss';

interface MessagesListItemProps {
  message: AdministrationListMessage;
  canEdit: boolean;
  canDelete: boolean;
  includeInactive: boolean;
  updating: boolean;
  updateMessage: UpdateHandler;
  deleteMessage: DeleteHandler;
  translation: AdministrationMessagesTranslation;
  formatters: DateFormatters;
}

export const MessagesListItem: React.FC<MessagesListItemProps> = ({
  message, canEdit, canDelete, includeInactive, updating, updateMessage, deleteMessage, translation, formatters
}) => {
  const dateFormatter = (date: string) => formatters.formatDate(parseAsDateUTC(date), {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <article
      className={`${styles.message} ${updating ? styles.updating : ''}`}>
      <header>
        <MeatballMenu className={styles.meatballMenu}>
          <li>
            <Link
              to={routeConstants.administrationMessagesItemFor(message.id)}
              className="dropdown-item">
              {translation.open_message}
            </Link>
          </li>
          {!!canEdit && <li>
            <MessagesListItemPublish
              message={message}
              updateMessage={updateMessage}
              includeInactive={includeInactive}
              disabled={updating}
              translation={translation} />
          </li>}
          {!!canDelete && <li>
            <DeleteMessageMenu
              id={message && message.id}
              onDelete={deleteMessage}
              disabled={updating}
              translation={translation} />
          </li>}
        </MeatballMenu>
        <div className="flex">
          <div className={`flex-grow ${styles.title}`}>
            <h3><Link
              to={routeConstants.administrationMessagesItemFor(message.id)}>
              {message.subject}
            </Link></h3>
          </div>
          {!message.active && <div className={styles.tag}>
            <Tag>{translation.inactive}</Tag>
          </div>}
          <div className={styles.date}>{dateFormatter(message.messageDate)}</div>
        </div>
      </header>
      <main>
        <ExpandableMessage
          message={message.message}
          translation={translation} />
      </main>
    </article>
  );
};
